import axios from 'axios';
import { getAuthToken } from '../utils/sessionAuth.js';

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/mac-scripts`;

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const jsonHeaders = () => ({ ...authHeaders(), 'Content-Type': 'application/json' });

const listBundles = async () => {
  const response = await axios.get(API_URL, { headers: authHeaders() });
  return response.data?.bundles || [];
};

const getBundle = async (id) => {
  const response = await axios.get(`${API_URL}/${encodeURIComponent(id)}`, { headers: authHeaders() });
  return response.data?.bundle;
};

const createBundle = async (payload) => {
  const response = await axios.post(API_URL, payload, { headers: jsonHeaders() });
  return response.data?.bundle;
};

const updateBundle = async (id, payload) => {
  const response = await axios.put(`${API_URL}/${encodeURIComponent(id)}`, payload, { headers: jsonHeaders() });
  return response.data?.bundle;
};

const deleteBundle = async (id) => {
  const response = await axios.delete(`${API_URL}/${encodeURIComponent(id)}`, { headers: authHeaders() });
  return response.data;
};

const publishBundle = async (id) => {
  const response = await axios.post(
    `${API_URL}/${encodeURIComponent(id)}/publish`,
    {},
    { headers: jsonHeaders() },
  );
  return response.data?.bundle;
};

const macScriptService = {
  listBundles,
  getBundle,
  createBundle,
  updateBundle,
  deleteBundle,
  publishBundle,
};

export default macScriptService;
